import React, { useState, useCallback, useEffect } from 'react';
import { supportsImageFormat } from '../../../../utils/type-check/supportsImageFormat.js';
import placeholderImg from './image/placeholder.png.js';
import placeholderImg2 from './image/placeholder-2.png.js';

const image = {
  v1: placeholderImg,
  v2: placeholderImg2
};
const ImageLoader = ({
  src,
  optimizedSrc,
  showPlaceholder,
  type = "v2",
  style,
  className,
  skeleton,
  ...props
}) => {
  const [loadedSrc, setLoadedSrc] = useState("");
  const init = useCallback(async () => {
    if (!optimizedSrc) {
      setLoadedSrc(src);
      return;
    }
    const isAvifSupport = await supportsImageFormat("avif");
    const isWebpSupport = await supportsImageFormat("webp");
    if (isAvifSupport && optimizedSrc.avif) {
      setLoadedSrc(optimizedSrc.avif);
    } else if (isWebpSupport && optimizedSrc.webp) {
      setLoadedSrc(optimizedSrc.webp);
    } else {
      setLoadedSrc(src);
    }
  }, [src, optimizedSrc]);
  const [isLoaded, setLoaded] = useState(false);
  const onLoad = useCallback(async () => {
    setLoaded(true);
    init();
  }, []);
  useEffect(() => {
    if (showPlaceholder) {
      setLoadedSrc(image[type]);
    } else {
      init();
    }
  }, [showPlaceholder, type, src]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !isLoaded || skeleton ? /* @__PURE__ */ React.createElement("div", { className: "skeleton_v2" }, /* @__PURE__ */ React.createElement("div", null), /* @__PURE__ */ React.createElement("div", null)) : null, skeleton !== true && !!loadedSrc ? /* @__PURE__ */ React.createElement(
    "img",
    {
      ...props,
      loading: "lazy",
      src: loadedSrc,
      style,
      onLoad,
      className,
      alt: "placeholder"
    }
  ) : null);
};
ImageLoader.displayName = "ImageLoader";

export { ImageLoader };
//# sourceMappingURL=index.js.map
